import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { FetchDriver, UploadDOTNumber } from 'src/constants/actionTypes'
import { captureSentryError } from 'src/utils/sentry'

interface UploadDOTNumberRequest {
  dotNumber: string
  stateOfIssue: string
  stepId: string
  lastSubmittedAt: string
  file: File
}

function* onUploadDOTNumber(action: AsyncAction<UploadDOTNumberRequest>) {
  const { dotNumber, stateOfIssue, stepId, lastSubmittedAt, file } = action.payload

  try {
    const formData = new FormData()

    formData.append('file', file)
    formData.append('stepId', stepId)
    formData.append('dotNumber', dotNumber)
    formData.append('stateOfIssue', stateOfIssue)
    formData.append('lastSubmittedAt', lastSubmittedAt)

    yield call(callClientSecureApi, Endpoints.UploadDOTNumber, {
      method: 'POST',
      body: formData,
      apiService: ApiService.Paraworks,
      resetContentType: true,
      returnResponse: true,
    })

    yield put(UploadDOTNumber.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.dotNumber.onUploadDOTNumber] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to upload DOT number'

    yield put(UploadDOTNumber.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* dotNumberSaga() {
  yield takeLatest(UploadDOTNumber.type.REQUEST, onUploadDOTNumber)
}
